import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarImageBackgroundIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        className="Icon toolbar-image-background"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                className="decoration"
                stroke="#48505E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M19.85 24.25h-6.663c-.555 0-.833 0-.962-.11a.46.46 0 0 1-.159-.384c.013-.169.21-.365.602-.758l5.962-6.878c.362-.363.544-.544.753-.612a.9.9 0 0 1 .567 0c.21.068.39.25.754.612l3.546 3.547m-4.4 4.583c1.54 0 2.31 0 2.898-.3a2.75 2.75 0 0 0 1.202-1.201c.3-.589.3-1.359.3-2.899v-.183m-4.4 4.583h-5.867m10.267-4.583v-1.834m-16.5 0v1.375m0-5.041v-1.375M12.666 7.75h1.5m-5.041.157a2.03 2.03 0 0 0-1.218 1.218m0 13.75a2.03 2.03 0 0 0 1.218 1.218M24.25 14.167v-1.375M19.334 7.75h-1.5m5.041.157a2.03 2.03 0 0 1 1.218 1.218M15.083 13.25a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarImageBackgroundIcon);
export default Memo;
